import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Sidebar, SidebarContent, SidebarFooter } from '@data-delivery/d3s';
import { useAuth } from '@data-delivery/okta-auth-react';
import { useLogout } from '../../hooks/use-logout';
import { type MenuItem, NavMain } from './nav-main';
import { NavUser } from './nav-user';
import { navigationItems } from './navigation-config';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const { logout } = useLogout();
  const userClaims = auth.user as Record<string, unknown> | undefined;
  const user = userClaims
    ? {
        given_name: String(userClaims.given_name || userClaims.FirstName || ''),
        family_name: String(userClaims.family_name || userClaims.LastName || ''),
        email: String(userClaims.email || userClaims.sub || ''),
        name: String(userClaims.name || ''),
      }
    : undefined;

  const handleSignOut = async () => {
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  const isMenuItemActive = (item: MenuItem): boolean => {
    if (item.url && item.url !== '#' && location.pathname === item.url) {
      return true;
    }

    if (item.items) {
      return item.items.some(subItem => location.pathname === subItem.url);
    }

    if (item.url && item.url !== '#' && item.url !== '/') {
      return location.pathname.startsWith(item.url);
    }

    return false;
  };

  const dynamicNavigationItems: MenuItem[] = navigationItems.map(item => ({
    ...item,
    isActive: isMenuItemActive(item),
  }));

  return (
    <Sidebar
      collapsible='icon'
      {...props}
      className='top-[--header-height] !h-[calc(100svh-var(--header-height))]'
    >
      <SidebarContent>
        <NavMain items={dynamicNavigationItems} />
        {/* <NavSecondary
          className='mt-auto'
          label='Account'
          items={[
            {
              title: 'User Info',
              url: '/user-info',
              icon: UserCircle,
            },
          ]}
        /> */}
      </SidebarContent>
      <SidebarFooter>{user ? <NavUser user={user} logOut={handleSignOut} /> : null}</SidebarFooter>
    </Sidebar>
  );
}
